import {Api, ApiExport} from '../../../Api.js'

const RESOURCE = 'product'
//const CancelToken = window.axios.CancelToken;
//let cancel;

export default {
    resource: RESOURCE,
    prefix: 'shop/',
    all(query) {
        return Api().get(this.prefix + this.resource + '/all'  + (query ? query : '') )
    },
    query(query) {
        //if(cancel){ cancel(); }
        return Api().get(
            this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    duplicate(id) {
        return Api().get(this.prefix + this.resource + '/duplicate/' + id)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    forceDelete(id) {
        return Api().delete(this.prefix + this.resource + '/force-delete/' + id)
    },
    generate(data) {
        return Api().post(this.prefix + this.resource + '/generate', data)
    },
    import(data) {
        return Api().post(this.prefix + this.resource + '/import', data)
    },
    export(query, filename) {
        return ApiExport(filename).get(this.prefix + this.resource + '/export' + (query ? query : ''),
            {
                responseType: 'blob', // important
            });
    },
    restore(id) {
        return Api().post(this.prefix + this.resource + '/restore/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/shop/product/ProductService.js